var _rect, _rect2, _path, _path2, _circle, _path3, _path4, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCannotFindIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#EEF0FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 254,
    height: 254,
    rx: 15,
    stroke: "#4A4A68",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0928 161.155C35.7941 152.002 75.351 145.898 94.1419 132.461C94.3839 132.288 94.684 132.231 94.9725 132.304L185.343 155.052C185.933 155.201 186.254 155.836 185.965 156.372C180.194 167.057 148.899 190.997 128.918 196.439C128.812 196.468 128.711 196.478 128.601 196.47C101.577 194.591 44.5373 173.848 22.2001 162.762C21.5461 162.437 21.4858 161.56 22.0928 161.155Z",
    fill: "#909DF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.32 159.018L157.756 154.99L172.358 200.08C172.698 201.131 172.122 202.258 171.071 202.599L162.441 205.394C161.39 205.734 160.262 205.158 159.922 204.107L145.32 159.018Z",
    fill: "#7EE8DE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.6013,
    cy: 128.353,
    r: 19.6218,
    fill: "#223BF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.116 113.113C102.083 106.575 90.8325 105.286 84.9625 108.058C80.7874 101.465 49.2483 83.5895 37.4675 99.2411C25.6867 114.893 52.0387 147.406 52.0387 147.406C52.0387 147.406 59.408 154.578 58.441 156.399C57.4741 158.22 56.1042 157.366 54.0414 155.851C54.4884 156.628 57.2572 158.681 55.9108 160.412C54.632 162.056 52.6941 160.526 51.253 158.782C51.8687 159.626 53.2443 161.982 52.172 163.152C50.9771 164.455 49.542 162.688 48.0883 161.055C48.7182 161.853 50.3022 164.52 49.3491 165.669C48.2816 166.957 44.4508 164.562 45.9655 166.077C47.4802 167.592 44.3948 171.675 33.7599 161.197C23.125 150.719 -4.8456 108.017 19.8941 81.5925C39.6858 60.4527 76.0623 69.2718 88.0258 77.3428C88.0258 77.3428 97.6012 53.0126 147.897 46.403C198.192 39.7934 236.732 81.5924 239.057 107.064C241.382 132.536 236.732 133.744 236.732 133.744C236.732 133.744 230.256 125.442 220.139 117.823C216.975 115.44 210.365 112.07 202.774 108.563C276.33 151.194 246.878 224.382 196.025 213.189C183.288 211.613 162.797 191.002 156.344 184.633C153.989 182.308 152.4 179.384 156 178.819C154.546 177.607 154.143 176.393 154.668 175.062C155.294 173.972 156.576 174.919 157.858 175.237C157.209 174.59 155.811 173.048 156.2 171.61C156.589 170.171 157.995 170.892 158.998 171.01C159.824 171.187 161.603 172.277 159.468 170.558C157.333 168.839 159.045 167.191 161.169 167.899C164.643 169.313 177.586 181.917 191.348 184.633C205.11 187.35 216.625 178.684 203.425 155.851C190.224 133.018 135.737 117.823 108.116 113.113Z",
    fill: "#223BF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1082 88.1946C73.6565 118.226 90.0894 150.154 119.812 159.508C149.535 168.863 181.292 152.102 190.743 122.071C200.195 92.0397 183.762 60.1114 154.04 50.7568C124.317 41.4022 92.5598 58.1636 83.1082 88.1946ZM93.6547 91.5135C86.0552 115.66 99.2679 141.331 123.166 148.853C147.064 156.374 172.598 142.897 180.197 118.751C187.797 94.6051 174.584 68.9335 150.686 61.412C126.788 53.8906 101.254 67.3674 93.6547 91.5135Z",
    fill: "#A2ECE5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 136.925,
    cy: 105.132,
    rx: 45.8345,
    ry: 45.3639,
    transform: "rotate(107.47 136.925 105.132)",
    fill: "#ECF7F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannotFindIllustration);
export default __webpack_public_path__ + "static/media/cannot-find-illustration.ea5f7f4d2003e2c8ec7b7c88721e30b7.svg";
export { ForwardRef as ReactComponent };